// tslint:disable: max-classes-per-file
// tslint:disable: no-inferrable-types
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BackendObjectRef } from '../lib/backend-integration.service';
import { State } from '../lib/state.model';
import { Transition } from '../lib/transition.model';
import { SelectControlGroup } from '../lib/workflow-editor.store';
import { WorkflowTransitionForm } from './transition-form.model';

export interface WorkflowTransitionFormOptions {
  transition: Transition|undefined;
  states: State[];
  roles: SelectControlGroup<BackendObjectRef>[];
}

@Component({
    selector: 'eas-workflow-transition-form',
    templateUrl: './transition-form.component.html',
    styleUrls: ['./transition-form.component.css'],
    standalone: false
})
export class WorkflowTransitionFormComponent implements OnInit {
  public readonly model: WorkflowTransitionForm;

  public constructor(formBuilder: FormBuilder,
                     @Inject(MAT_DIALOG_DATA) data: WorkflowTransitionFormOptions,
                     private dialogRef: MatDialogRef<WorkflowTransitionFormComponent>) {
    this.model = new WorkflowTransitionForm(formBuilder,
                                            data.transition,
                                            data.states,
                                            data.roles);
  }

  public ngOnInit(): void { }

  // Compare function for mat-select to handle objects
  public compareOptionsByID(o1: any, o2: any) {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  //
  // Actions
  //

  public onSave(): void {
    this.dialogRef.close(this.model.value);
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  //
  // Template helpers
  //

  public shouldShowError(controlOrErrorCode: string): boolean {
    return this.model.dirty &&
           (this.model.isInvalid(controlOrErrorCode) ||
            this.model.hasError(controlOrErrorCode));
  }

  getDialogTitle() {
    return this.model.isAddingTransition ? $localize `ADD NEW TRANSITION` : $localize `EDIT TRANSITION`;
  }
}
